import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { ClerkWithRouter } from './auth/ClerkWithRouter'
import App from './App'
import { installChunkReload } from './lib/chunk-reload'
import { PageErrorBoundary } from './components/PageErrorBoundary'
import './index.css'

const publishableKey = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY as string

if (!publishableKey) {
  throw new Error('Missing VITE_CLERK_PUBLISHABLE_KEY — add it to apps/web/.env')
}

// A tab left open across a deploy reloads itself instead of going blank when a screen's file is gone (lib/chunk-reload.ts).
installChunkReload()

const rootEl = document.getElementById('root')
if (!rootEl) throw new Error('Root element #root not found — check index.html')
ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    {/* DEF-97: the router sits OUTSIDE Clerk so Clerk can navigate with react-router (no full page reload). */}
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <ClerkWithRouter publishableKey={publishableKey}>
        {/* DEF-216: anything that fails outside a screen shows "did not load" + Reload, never a white page. */}
        <PageErrorBoundary scope="app">
          <App />
        </PageErrorBoundary>
      </ClerkWithRouter>
    </BrowserRouter>
  </React.StrictMode>,
)
